// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/category/_index.scss
// module id = 48
// module chunks = 0